import { useQuery } from '@tanstack/react-query';
import { fetcher } from 'src/api/fetcher';
import { API_RESOURCES } from 'src/utils/constants';

export const useLotsByUris = (materialLotUris, lotKey = 'material-lots') => {
  return useQuery({
    queryKey: ['material-lots-by-uris', lotKey, materialLotUris],
    queryFn: () =>
      fetcher(API_RESOURCES.MATERIAL_LOT, {
        params: {
          'filter[uri]': materialLotUris,
        },
      }),
    enabled: !!materialLotUris && materialLotUris.length > 0,
    select: data => {
      const resources = data.resources;
      return resources;
    },
  });
};
